var map = {
	"./all-styles.svg": "b47f",
	"./back.svg": "7338",
	"./basket.svg": "382e",
	"./carousel.svg": "2246",
	"./cart.svg": "daca",
	"./down.svg": "d8aa",
	"./drop-gradient.svg": "44fb",
	"./drop.svg": "c63c",
	"./edit.svg": "daf0",
	"./font-c copy.svg": "c352",
	"./font-h.svg": "b748",
	"./font-m.svg": "0e97",
	"./font-p.svg": "fe39",
	"./grid.svg": "4b05",
	"./heart.svg": "7d16",
	"./heart2.svg": "b067",
	"./ideas copy.svg": "91b6",
	"./logout.svg": "69e3",
	"./next.svg": "0043",
	"./preview.svg": "774c",
	"./select.svg": "9878",
	"./share.svg": "bd5b",
	"./tech.svg": "5569",
	"./user.svg": "6aed",
	"./v-menu.svg": "d05c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";